"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'c_select_item',
  props: {
    configObj: {
      type: Object
    },
    configNme: {
      type: String
    }
  },
  data: function data() {
    return {
      defaults: {},
      configData: {},
      batchWord: '',
      visible: false
    };
  },
  created: function created() {
    this.defaults = this.configObj;
    this.configData = this.configObj[this.configNme];
  },
  watch: {
    configObj: {
      handler: function handler(nVal, oVal) {
        this.configData = nVal[this.configNme];
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleConfirm: function handleConfirm() {
      // 执行确认操作
    },
    handleCancel: function handleCancel() {
      // 执行取消操作
    },
    cancel: function cancel(num) {
      this.visible = false;
      if (num == 2) {
        var arr = this.batchWord.split('\n');
        var arrNew = [];
        arr.forEach(function (item) {
          var obj = {};
          obj['val'] = item;
          arrNew.push(obj);
        });
        this.configData.list = this.configData.list.concat(arrNew);
      }
      this.batchWord = '';
    },
    addHotTxt: function addHotTxt() {
      var obj = {
        val: ''
      };
      this.configData.list.push(obj);
    },
    // 删除数组
    bindDelete: function bindDelete(index) {
      this.configData.list.splice(index, 1);
    }
  }
};